import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import PredictionConfig from '@/components/PredictionConfig'
import PredictionPage from '@/components/PredictionPage'
import Report from '@/components/Report'

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/',
      name: "Dashboard",
      component: Dashboard,
      meta: {
        title: 'Dashboard',
      }
    },
    {
      path: '/predictionConfig/:configId',
      name: "PredictionConfig",
      component: PredictionConfig,
      meta: {
        title: 'PredictionConfig',
      }
    },
    {
      path: '/races/:raceId',
      name: "RacePage",
      component: PredictionPage,
      meta: {
        title: 'RacePage',
      }
    },
    {
      path: '/predictionConfig/',
      name: "PredictionConfigList",
      component: PredictionConfig,
      meta: {
        title: 'PredictionConfig',
      }
    },
    {
      path: '/races/',
      name: "PredictionPage",
      component: PredictionPage,
      meta: {
        title: 'PredictionPage',
      }
    },
    {
      path: '/report/',
      name: "ReportList",
      component: Report,
      meta: {
        title: 'Report',
      }
    },
    {
      path: '/report/:datasetNumber/:configName',
      name: "Report",
      component: Report,
      meta: {
        title: 'Report',
      }
    }
  ]
})

export default router
